import { render, staticRenderFns } from "./OverviewHistoryTable.vue?vue&type=template&id=1979f666"
import script from "./OverviewHistoryTable.vue?vue&type=script&lang=js"
export * from "./OverviewHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports